import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { getTranslation } from '../../../utils/const/translation';

@Injectable()
export class CityMetasResolver  {

  constructor(
  ) {
  }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> {
      if (route.params && route.params.citySlug) {
        route.data = {...route.data, ...{
            breadcrumbRedirect: route.params.citySlug,
            breadcrumb: getTranslation(route.data.breadcrumbKey, {cityName : route.params.city})
          }};

        return of(route.params.citySlug);
      }

      return of(null);
  }
}
